import { Alert } from "@vericus/cadmus-ui";

import * as styles from "./dialogue/socratic-dialogue.css";

export const PreparationPhaseTip = ({
  preparationEndDatePassed,
  isRecording,
  isDialogueCompleted,
}: {
  preparationEndDatePassed: boolean;
  isRecording: boolean;
  isDialogueCompleted: boolean;
}) => {
  if (preparationEndDatePassed || isRecording || isDialogueCompleted)
    return null;

  return (
    <Alert
      severity={"info"}
      withIcon={false}
      className={styles.contentColumn}
    >
      Please use this time to organise your thoughts and prepare your response.
      Recording will start automatically once the countdown ends. You can start
      the recording earlier by clicking the &quot;Start Recording Early&quot;
      button.
    </Alert>
  );
};
